import React from "react";
import Chart from "../../Chart";
import ExampleHeatmap from "../../../../components/Chart/ExampleHeatmap";

class HeatmapExampleApplet extends Chart {

    render() {
        return <ExampleHeatmap applet={this}
                          attributes={this.state.Attributes}
                          xAxis={this.state.xAxis}
                          yAxis={this.state.yAxis}
                          series={this.state.Series}
                          sx={this.state.sx}
                          enterpriseComponent={this.getEnterpriseComponent()} />;
    }

    state = {
        Name: "HeatmapExampleApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        Attributes: {
            Height: 300,
            Margin: {right: 24},
        },
        xAxis: [
            {
                scaleType: 'band',
                data: []
            }
        ],
        yAxis: [
            {
                scaleType: 'band',
                data: []
            }
        ],
        zAxis: undefined,
        Series: [
            {
                type: "heatmap",
                data: [],
                id: "heatId",
                label: "heat",
            }
        ]
    }
}

export default HeatmapExampleApplet;
